import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import translate from '../../helpers/translate';
import ListProducts from './ListProducts';
import { useRecommendedMenu } from '../../hooks/useRecommended';
import Item from '../../screens/menu/list/theme2/intenList';
import DetailProduct from './DetailProduct';
import SpecialScreen from './special';
import HappyScreen from './happy';
import LiquourScreen from './liquour';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showLiquour, setShowLiquour] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dishs, setdishs] = useState(false);

    const Menu = useRecommendedMenu();

    const [dataPollo, setDataPollo] = useState(false);
    const [dataDrink, setDataDrink] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [location, setlocation] = useState('Home');
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


    useEffect(() => {
        menus.map((item) => {
        if (item.id === 39) {
            setDataPollo(item);
        }
        if (item.id === 60) {
            setDataDrink(item);
        }

        if (item.id === 42) {
            setDataDish(item);
        }
        });
    }, [menus]);


      useEffect(() => {
            const handleVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                console.log("La página ha perdido el foco (está oculta).");
                setScreen('home');
                getInitData();
            } else if (document.visibilityState === "visible") {
                console.log("La página está en foco (visible).");
            }
            };
            document.addEventListener("visibilitychange", handleVisibilityChange);
    
            // Limpieza del evento al desmontar el componente
            return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            };
      }, []);
    
    
       window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };
    

    const [screen, setScreen] = useState('home');
    
 
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent setScreen={setScreen} setdishs={setdishs} showBack={false} showLogo={false}>
            {screen === 'home' && <>
                <div>
                <div  style={{ marginTop: -2}}>
                    <video src={require('./assets/popoc_media3.mp4')} loop autoPlay={true} muted style={{
                        width: '100%',
                        height: 320,
                        borderRadius: 14,
                        objectFit: "cover",
                       
                    }}/>
                </div>


                <div
                    
                    style={{
                      display:'flex',
                    flexDirection: 'row',
                        justifyContent: 'space-between',
                    marginTop: 20,
                  }}>
                    <div
                        onClick={()=>setShowSpecials(true)}
                    style={{width: '49%'}}>
                                <img
                                    onContextMenu={(e) => e.preventDefault()}
                      src={
                        require('./assets/specialsEN.png')
                      }
                    
                      style={{width: '100%', height: 170, borderRadius: 14, pointerEvents: 'none',}}
                    />
                  </div>
                    <div
                         onClick={()=>setShowHappy(true)}
                    style={{width: '49%'}}>
                                <img
                                    onContextMenu={(e) => e.preventDefault()}
                      src={require('./assets/happyhour.png')}
                     
                      style={{width: '100%', height: 170, borderRadius: 14, pointerEvents: 'none',}}
                    />
                  </div>
                </div>

                <div
                    onClick={()=>setShowLiquour(true)}
                 >
                            <img
                                 onContextMenu={(e) => e.preventDefault()}
                    src={require('./assets/image.png')}
                    style={{
                        width: '100%',
                        pointerEvents: 'none',
                      height: 170,
                      borderRadius: 14,
                      marginTop: 20,
                    }}
                  />
                </div>
              
            </div>

            <div>
                <p
                    style={ {fontSize: 25, textTransform: 'uppercase',fontFamily: 'LondrinaSolidRegular', color: '#fff', marginTop: 20, marginBottom: 10, textAlign: 'left'}}>
                    Nuestros Recomendados
                </p>

                <div style={{
                    display: 'grid',
                    gap: '16px',
                      gridTemplateColumns: 'repeat(2, 1fr)',
                }}>
                    {Menu &&
                    Menu.map((item) => (
                        <Item
                            key={item.id.toString()}
                            menu={item}
                            allDish={Menu}
                            setShowQr={() => {}}
                            setUriShare={() => {}}
                            titleCategorie={''}
                            onPress={() => {
                                setDataDish({ dish: item, alldish: Menu, currentDish: item })
                                setScreen('detailproduct')
                                setlocation('Home')
                            }
                            }
                        />
                    ))
                }
                </div>
                

            </div>
            </>}

            {screen === 'listproduct' && <ListProducts
                dishs={dishs}
                setScreen={setScreen}
                    setDataDish={setDataDish}
                    setlocation={setlocation}
                setShowListProduct={setShowListProduct}
            />}

            {screen === 'detailproduct' && <DetailProduct
                dishMenu={dataDish}
                setdishs={setdishs}
                    setScreen={setScreen}
                    location={location}
                setShowDetailProduct={setShowDetailProduct}
                />}

            {showSpecials && <SpecialScreen
                setShowSpecials={setShowSpecials}
            />}

            {showHappy && <HappyScreen
                setShowSpecials={setShowHappy}
            />}
            {showLiquour && <LiquourScreen
                setShowSpecials={setShowLiquour}
            />}
            </LayoutContent>
        </div>
    );
}

export default Index;